import PropTypes from 'prop-types';
import { Tab, Tabs as ReactTabs, TabList, TabPanel } from 'react-tabs';
import 'react-tabs/style/react-tabs.css';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
function Tabs(props) {
  const onClickTab = (newIndex, previousIndex) => {
    if (!props.onChange) {
      return;
    }
    if (newIndex !== previousIndex) {
      props.onChange(newIndex, previousIndex);
    }
  };
  return /*#__PURE__*/_jsxs(ReactTabs, {
    onSelect: (index, lastIndex) => onClickTab(index, lastIndex),
    children: [/*#__PURE__*/_jsx(TabList, {
      children: props.items.map(item => /*#__PURE__*/_jsx(Tab, {
        children: item.label
      }, item.label))
    }), props.items.map(item => /*#__PURE__*/_jsx(TabPanel, {
      children: item.content
    }, item.label))]
  });
}
Tabs.propTypes = {
  items: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string.isRequired,
    content: PropTypes.object.isRequired
  })).isRequired,
  onChange: PropTypes.func
};
export { Tabs };